var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.666748C4.70638 0.666748 2.8335 2.53963 2.8335 4.83342C2.8335 7.1272 4.70638 9.00008 7.00016 9.00008C9.29395 9.00008 11.1668 7.1272 11.1668 4.83342C11.1668 2.53963 9.29395 0.666748 7.00016 0.666748ZM7.00016 1.91675C8.6184 1.91675 9.91683 3.21518 9.91683 4.83342C9.91683 6.45165 8.6184 7.75008 7.00016 7.75008C5.38193 7.75008 4.0835 6.45165 4.0835 4.83342C4.0835 3.21518 5.38193 1.91675 7.00016 1.91675ZM1.99121 10.6667C1.08296 10.6667 0.333496 11.4162 0.333496 12.3245V12.9584C0.333496 14.4602 1.28319 15.6218 2.5446 16.3178C3.806 17.0137 5.40354 17.3334 7.00016 17.3334C8.59679 17.3334 10.1943 17.0137 11.4557 16.3178C12.5313 15.7244 13.3407 14.7762 13.5675 13.5834H13.6676V12.3245C13.6676 11.4162 12.9174 10.6667 12.0091 10.6667H1.99121ZM1.99121 11.9167H12.0091C12.2417 11.9167 12.4176 12.0919 12.4176 12.3245V12.3334H12.4168V12.9584C12.4168 13.9567 11.8561 14.67 10.8519 15.224C9.84767 15.7781 8.42437 16.0834 7.00016 16.0834C5.57595 16.0834 4.15266 15.7781 3.14844 15.224C2.14422 14.67 1.5835 13.9567 1.5835 12.9584V12.3245C1.5835 12.0919 1.75863 11.9167 1.99121 11.9167Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24User);
export default __webpack_public_path__ + "static/media/icn_24x24_user.ccd1520aa3fed827e7dff307d5c8e9b0.svg";
export { ForwardRef as ReactComponent };